import { createContext, useContext } from "react";
import "./StarIcon.scss";

// Shop's star icon SVG (global_display.star_icon.html of the guest shop API),
// provided by PortalShell. null = keep each place's built-in star.
export const StarIconContext = createContext(null);

// One rating star, painted with `color` (CSS colour or variable): every shape
// of the icon fills with currentColor. `fallback` is the built-in SVG shown
// when the shop has no star icon; it should fill with currentColor too.
const StarIcon = ({ color, size, className = "", fallback }) => {
    const html = useContext(StarIconContext);
    return (
        <span
            className={`ts-star-icon ${className}`.trim()}
            style={{ color, width: size, height: size }}
        >
            {html ? (
                <span
                    className="ts-star-icon__custom"
                    dangerouslySetInnerHTML={{ __html: html }}
                />
            ) : (
                fallback
            )}
        </span>
    );
};

export default StarIcon;
